/* eslint-env browser, jquery */
import 'bootstrap';
import domify from 'domify';
import page from 'modules/ab-page-js';
import $ from 'jquery';
import aos from 'aos';
import scrollIntoView from 'scroll-into-view';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm } from 'components';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import React from 'react';
import Animation from 'modules/animation-timeline';
import querystring from 'querystring';
import AnimationScroll from 'modules/animation-scroll';
import container from 'modules/section-content';
import splash from './view/landing.pug';
import metadata from './metadata.json';
import { throttle } from 'lodash';
import inView from 'in-view';
import lottie from 'lottie-web';
//animation json imports
import heroAnimationData from './animations/hero.json';
import legacyAnimationData from './animations/legacy.json';
import modernizeAnimationData from './animations/modernize.json';
import identityAnimationData from './animations/identity.json';
import auth0AnimationData from './animations/auth0.json';

const animationScroll = new AnimationScroll();
const metricsLib = window.metricsLib;

export default function register() {
  page('/app-modernization', render, snippets);
  page.exit('/app-modernization', unmountContactForm, resetAnimation);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm
      source="App Modernization"
      subject="New lead from App Modernization landing page"
      formId="app-modernization-contact-form"
    />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  aos.init();
  setupClickHandlers();
  setupContactForm();
  setupAnimations();
  setupLottieAnimations();
  next();
}

function setupClickHandlers() {
  const legacyTargetElem = document.getElementById('scroll-spy-legacy');
  const modernizeTargetElem = document.getElementById('scroll-spy-modernize');
  const identityTargetElem = document.getElementById('scroll-spy-identity');
  const auth0TargetElem = document.getElementById('scroll-spy-auth0');

  const $legacySection = $('.app-modernization-page section[role="navigation"] .section-legacy');
  const $modernizeSection = $(
    '.app-modernization-page section[role="navigation"] .section-modernize'
  );
  const $identitySection = $(
    '.app-modernization-page section[role="navigation"] .section-identity'
  );
  const $auth0Section = $('.app-modernization-page section[role="navigation"] .section-auth0');

  $legacySection.on('click', () => scrollIntoView(legacyTargetElem, { time: 500 }));
  $modernizeSection.on('click', () => scrollIntoView(modernizeTargetElem, { time: 500 }));
  $identitySection.on('click', () => scrollIntoView(identityTargetElem, { time: 500 }));
  $auth0Section.on('click', () => scrollIntoView(auth0TargetElem, { time: 500 }));
}

function setupContactForm() {
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:b2b-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:b2b-contact-form', metricsData);
    },
    source: 'app-modernization-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  const salesFormButton = document.querySelector('.open-contact-form-modal');
  const ttsMetadata = { place: 'hero', type: 'button', text: 'talk to sales' };
  salesFormButton.addEventListener('click', () =>
      metricsLib.track('click:contact-sales', { trackData: { ...ttsMetadata } }, () => window.location.assign(`/contact-us?${querystring.stringify(ttsMetadata)}`))
  );
}

function setupAnimations() {
  const $navigation = $('#app-modernization-page-navigation');
  const $legacySection = $('#app-modernization-page-navigation .section-legacy span');
  const $modernizeSection = $('#app-modernization-page-navigation .section-modernize span');
  const $identitySection = $('#app-modernization-page-navigation .section-identity span');
  const $auth0Section = $('#app-modernization-page-navigation .section-auth0 span');

  animationScroll.addScrollSpy({
    id: 'scroll-spy-container',
    onEnter: () => $navigation.addClass('fixed'),
    onLeave: () => $navigation.removeClass('fixed')
  });

  animationScroll.addScrollSpy({
    id: 'scroll-spy-legacy',
    onEnter: () => $legacySection.parent().addClass('section-active'),
    onLeave: () => $legacySection.parent().removeClass('section-active')
  });

  animationScroll.addScrollSpy({
    id: 'scroll-spy-modernize',
    onEnter: () => $modernizeSection.parent().addClass('section-active'),
    onLeave: () => $modernizeSection.parent().removeClass('section-active')
  });

  animationScroll.addScrollSpy({
    id: 'scroll-spy-identity',
    onEnter: () => $identitySection.parent().addClass('section-active'),
    onLeave: () => $identitySection.parent().removeClass('section-active')
  });

  animationScroll.addScrollSpy({
    id: 'scroll-spy-auth0',
    onEnter: () => $auth0Section.parent().addClass('section-active'),
    onLeave: () => $auth0Section.parent().removeClass('section-active')
  });

  animationScroll.start();
}

function setupLottieAnimations() {
  const $heroAnimationContainer = document.getElementById('hero-animation-container');
  const $legacyAnimationContainer = document.getElementById('legacy-animation-container');
  const $modernizeAnimationContainer = document.getElementById('modernize-animation-container');
  const $identityAnimationContainerLeft = document.getElementById(
    'identity-animation-container-left'
  );
  const $identityAnimationContainerRight = document.getElementById(
    'identity-animation-container-right'
  );
  // const $auth0AnimationContainer = document.getElementById('auth0-animation-container');

  const heroAnimationParams = {
    container: $heroAnimationContainer,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: heroAnimationData
  };

  const legacyAnimationParams = {
    container: $legacyAnimationContainer,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    animationData: legacyAnimationData
  };

  const modernizeAnimationParams = {
    container: $modernizeAnimationContainer,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    animationData: modernizeAnimationData
  };

  const identityAnimationParamsLeft = {
    container: $identityAnimationContainerLeft,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: identityAnimationData
  };

  const identityAnimationParamsRight = {
    container: $identityAnimationContainerRight,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    animationData: identityAnimationData
  };

  // const auth0AnimationParams = {
  //   container: $auth0AnimationContainer,
  //   renderer: 'svg',
  //   loop: true,
  //   autoplay: false,
  //   animationData: auth0AnimationData
  // };

  const heroAnimation = lottie.loadAnimation(heroAnimationParams);
  const legacyAnimation = lottie.loadAnimation(legacyAnimationParams);
  const modernizeAnimation = lottie.loadAnimation(modernizeAnimationParams);
  const identityAnimationLeft = lottie.loadAnimation(identityAnimationParamsLeft);
  const identityAnimationRight = lottie.loadAnimation(identityAnimationParamsRight);
  // const auth0Animation = lottie.loadAnimation(auth0AnimationParams);

  var legacyPlayState = false;
  var modernizePlayState = false;
  var identityAnimationRightPlayState = false;
  // var auth0AnimationPlayState = false;

  inView.threshold(0.5);

  const playAnimationsIfVisible = throttle(() => {
    if (!legacyPlayState && inView.is($legacyAnimationContainer)) {
      legacyAnimation.play();
    }
    if (!modernizePlayState && inView.is($modernizeAnimationContainer)) {
      modernizeAnimation.play();
    }
    if (!identityAnimationRightPlayState && inView.is($identityAnimationContainerRight)) {
      identityAnimationRight.play();
    }
    // if (!auth0AnimationPlayState && inView.is($auth0AnimationContainer)) {
    //   auth0Animation.play();
    // }
  }, 300);

  playAnimationsIfVisible();

  document.addEventListener('scroll', playAnimationsIfVisible);
}

function unmountContactForm(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  next();
}

function resetAnimation(ctx, next) {
  animationScroll.reset();
  next();
}



// WEBPACK FOOTER //
// ./src/pages/app-modernization/client.js